import React, { Component } from "react";
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';

import { search } from 'AppCore/Utils/Search';
import { getProducts } from 'AppCore/Actions';

import HasPermissions from 'AppCore/Components/HasPermissions';

import SearchField from 'AppCore/Components/SearchField';
import ActivityIndicator from "AppCore/Components/ActivityIndicator";
import ProductsTable from 'AppCore/Components/DataTable/products';
import InputField from 'AppCore/Components/Form/inputField';

import EditCreateProductModal from 'Screens/App/Modals/Product/editCreate';

import { PageContainer, Content } from '../Layout';
import Header, { HeaderActionContainer, Button as HeaderButton } from '../Layout/Header';

import { sort as sortProduct } from 'AppCore/Utils/Product'

class ProductsScreen extends Component {

	state = {
		products : null, modalEdit: null, modalCreate: null, searchQuery: '',
		displayDisabledObjects: false
    }

	componentDidMount = async () => {
		this.props.getProducts();
	}

	renderLoading() {
		return <ActivityIndicator />
	}

	onClickEdit = id => {
		this.setState({
			modalEdit: {
				id,
				open: true
			}
		})
	}

	onClickCreate = () => {
		this.setState({
			modalCreate: {
				open: true
			}
		})
	}

	render() {

		const { searchQuery, displayDisabledObjects } = this.state;
        const { products: { data, loaded } } = this.props;

		if (!loaded) {
			return this.renderLoading();
		}

		const filteredObjs = search({
			query: searchQuery,
			data: data.filter(obj => obj.disabled === displayDisabledObjects),
			attrs: ['name', 'sku', 'category']
		})

		return (
			<PageContainer>

				<Header title="Produits - SKU">
					<HeaderActionContainer>
						<SearchField
							id="outlined-with-placeholder"
							label="Rechercher"
							placeholder="Rechercher"
							variant="outlined"
							value={searchQuery}
							onChange={({ target: { value: searchQuery }}) => this.setState({ searchQuery })}
						/>
						<HasPermissions permissions={['create_product']}>
							<HeaderButton onClick={this.onClickCreate}>
								Nouveau produit
							</HeaderButton>
						</HasPermissions>

					</HeaderActionContainer>
				</Header>

				<div style={{width: '100%'}}>
					<InputField
						value={displayDisabledObjects}
						type="switch"
						label={!displayDisabledObjects ? "Afficher les produits supprimés" : "Revenir à la liste des produits"}
						onChange={displayDisabledObjects => this.setState({ displayDisabledObjects })}
					/>
				</div>

				<Content>
					<ProductsTable
						data={filteredObjs}
						onClickEdit={this.onClickEdit}
						sort={sortProduct}
					/>

					{(this.state.modalEdit || this.state.modalCreate) &&
						<EditCreateProductModal
							aria-labelledby="simple-modal-title"
							aria-describedby="simple-modal-description"
							open
							id={this.state.modalEdit ? this.state.modalEdit.id : null}
							onClose={() => this.setState({ modalEdit: null, modalCreate: null })}
							onSaved={() => this.setState({ modalEdit: null, modalCreate: null })}
						/>
					}
				</Content>

			</PageContainer>
		);
	}

}


export default connect(
	state => ({
		products: state.products
	}),
	{ getProducts }
)(withSnackbar(ProductsScreen));